import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, UrlSegment } from '@angular/router'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { AppUsageService } from '../../../_shared/services/app-usage.service'

@Component({
  selector: 'app-app-usage',
  templateUrl: './app-usage.component.html',
  styleUrls: ['../referrals.component.scss', './app-usage.component.scss'],
})
export class AppUsageComponent implements OnInit, OnDestroy {
  label: string
  url: UrlSegment[]
  tag: string
  private unsubscribe$ = new Subject()
  constructor(
    private service: AppUsageService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.data.pipe(takeUntil(this.unsubscribe$)).subscribe((values) => {
      this.label = values.label
      this.service.setCurrentTag(values.tag)
    })
    this.route.url.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      this.url = value
    })
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
